module.exports = __webpack_public_path__ + "static/media/forever_tricolour_small_2.e4d6055b.jpg";